import React from 'react'
import {Field} from 'redux-form'
import {required} from '../../lib/validators';
import FlatButton from 'material-ui/FlatButton';
import {TextField} from 'redux-form-material-ui';
import { Grid, Row, Col } from 'react-flexbox-grid';
import translate from '../../lib/i18n/translate'
import MenuPage from '../../pages/MenuPage';

import './Operator.css';

const OperatorForm = (props) => {
    const {handleSubmit, deleteOperator} = props;
    const {UserId, FirstName, LastName, Pin, Save, Delete, Operator} = props.strings;

    return (
        <MenuPage title={Operator}>

        <div className="container">

        <form onSubmit={handleSubmit}>
        <Grid fluid>
            <Row>
                <Col xs={12} sm={6} md={4} lg={3} mdOffset={2} lgOffset={3} >
                    <Field name="firstName" validate={[required]} component={TextField} hintText={FirstName}
                        fullWidth={true}
                        floatingLabelText={FirstName}/>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3} >
                    <Field name="lastName" validate={[required]} component={TextField} hintText={LastName}
                        fullWidth={true}
                        floatingLabelText={LastName}/>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={6} md={4} lg={3} mdOffset={2} lgOffset={3} >
                    <Field name="userId" validate={[required]} component={TextField} hintText={UserId}
                        fullWidth={true}
                        floatingLabelText={UserId}
                        disabled={props.initialValues && props.initialValues.id !== 0 ? true:false}/>
                </Col>
                <Col xs={12} sm={6} md={4} lg={3} >
                    <Field name="pin" validate={[required]} component={TextField} hintText={Pin}
                        fullWidth={true}
                        floatingLabelText={Pin}/>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={6} md={4} lg={3} smOffset={6} style={{textAlign: 'right'}} >
                    <div className="ButtonWrapper">
                        <FlatButton type="submit" backgroundColor="#fff"
                            fullWidth={false}
                            style={{marginLeft: '1rem'}}
                            label={Save} />
                        <FlatButton type="button" backgroundColor="#fff" label={Delete}
                            fullWidth={false}
                            style={{marginLeft: '1rem'}}
                            onTouchTap={deleteOperator} />
                    </div>
                </Col>
            </Row>
        </Grid>
        </form>
        </div>
        </MenuPage>
    )
};

export default translate('OperatorForm')(OperatorForm);



// WEBPACK FOOTER //
// ./src/components/operator/OperatorForm.js